import { useRoute, useParams } from "@bcm-dev/bcms-vite";
import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";
import { UIPrimaryButton } from "components/ui/UIButton";
import React from "react";
import { SVGAsset } from "res";
import "./styles.css";
/**
 * @function ManagePinPage
 * @return {React.Component}
 * @exported true
 * @description The main component for ManagePinPage
 */

export default function ManagePinPage(props) {
  const navigate = useRoute();
  const cardID = useParams().cardID ?? "0";

  const route = evt => navigate(`/home/recenttransactions/${ cardID }`);

  return (
    <MainContentContainer 
      className="manage-pin-page" 
      header={
        <MainContentHeader text="Manage Pin" onClick={ route } />
      }>
      
      <div className="manage-pin-content-container">
        <div className="framed-icon-container">
          <SVGAsset id="PinIcon" />
        </div>
        <p className="text-center"> <span data-point="Manage_Pin_Phone">Call us</span> to set or change your PIN.</p>
        <div className="text-center">
          <UIPrimaryButton text="OK" onClick={ route } dataPoint="Manage_Pin_OK"/>
        </div>
      </div>
    </MainContentContainer>
  );
}